import React, { useState } from "react";
import classNames from "classnames";
import ConvertSvgToComponent from "components/ConvertSvgToComponent";
import { useTeamContext } from "store/contexts/teamContext";

export default ({ type = "status", setType, setDisplayModal }) => {
  const { team } = useTeamContext();
  const [showPostTypes] = useState({
    status: {
      icon: "article",
      label: "Status",
    },
    celebration: {
      icon: "celebration",
      label: "Wall of fame",
    },
    brightidea: {
      icon: "brightidea",
      label: "Bright Idea/Announcement",
    },
    teamvideo: {
      icon: "teamvideo",
      label: "Team Video",
    },
    slideshow: {
      icon: "slideshow",
      label: "Slideshow",
    },
  });
  const [postTypes] = useState(checkUserRole);

  function checkUserRole() {
    if ([3, 2].includes(team?.role_id)) {
      return Object.assign(showPostTypes, {
        checkin: {
          icon: "checkin",
          label: "Check-in",
        },
      });
    }

    return showPostTypes;
  }

  const handleType = (typeKey) => {
    setType(typeKey);
    setDisplayModal(true);
  };

  return (
    <div className="pills-button ">
      {Object.keys(postTypes).map((typeKey) => (
        <div
          key={typeKey}
          className={classNames({
            "button-types": true,
            active: typeKey === type,
          })}
          onClick={() => handleType(typeKey)}
        >
          <ConvertSvgToComponent
            icon={postTypes[typeKey].icon}
            imageclass="mwh-12"
          />
          {postTypes[typeKey].label}
          <div></div>
        </div>
      ))}
    </div>
  );
};
